export enum MediaAdvertisementType {
  VAST = "VAST",
  VPAID = "VPAID",
  SIMID = "SIMID",
  VMAP = "VMAP"
}
